'use client';

import { c as _c } from "react/compiler-runtime";
import type { ImageProps } from 'next/image';
import type React from 'react';
import Image from 'next/image';
import { BRAND_PRIMARY, BRAND_PRIMARY_INVERTED, BRAND_SYMBOL, BRAND_SYMBOL_INVERTED } from 'src/constants/styles';
import { styled } from '@mui/material/styles';
import { FlexColumn } from 'src/components/Atoms/FlexBox';
import { shouldForwardPropFn } from 'src/components/Particles/Particles';
interface BrandProps {
  small?: boolean;
  className?: string;
}
type BrandImageProps = Omit<ImageProps, 'src' | 'width' | 'height'> & {
  small?: boolean;
  inverted?: boolean;
};
const shouldForwardProp = shouldForwardPropFn(['small', 'inverted']);
const StyledBrandBox = styled(FlexColumn, {
  shouldForwardProp
})<BrandProps>(({
  theme
}) => ({
  zIndex: theme.zIndex.drawer + 1,
  alignItems: 'flex-start',
  justifyContent: 'center',
  alignSelf: 'stretch',
  padding: `${theme.sizes.spacing.none} ${theme.sizes.spacing['07']}`
}));
const StyledImage = styled(Image, {
  shouldForwardProp
})<BrandImageProps>(({
  theme
}) => ({
  zIndex: theme.zIndex.drawer + 1
}));
const getCurrentBrand = (small: boolean, inverted: boolean) => {
  if (inverted) {
    return small ? BRAND_SYMBOL_INVERTED : BRAND_PRIMARY_INVERTED;
  }
  return small ? BRAND_SYMBOL : BRAND_PRIMARY;
};
const BrandImage: React.FC<BrandImageProps> = props => {
  const $ = _c(8);
  const t0 = props.small || false;
  const t1 = props.inverted || false;
  let t2;
  if ($[0] !== t0 || $[1] !== t1) {
    t2 = getCurrentBrand(t0, t1);
    $[0] = t0;
    $[1] = t1;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const {
    src,
    width,
    height
  } = t2;
  let t3;
  if ($[3] !== height.px || $[4] !== props || $[5] !== src || $[6] !== width.px) {
    t3 = <StyledImage {...props} src={src} width={width.px} height={height.px} alt="Brand" preload={true} />;
    $[3] = height.px;
    $[4] = props;
    $[5] = src;
    $[6] = width.px;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  return t3;
};
const Brand: React.FC<BrandProps> = t0 => {
  const $ = _c(5);
  const {
    small: t1,
    className
  } = t0;
  const small = t1 === undefined ? false : t1;
  let t2;
  if ($[0] !== small) {
    t2 = <BrandImage small={small} alt="Brand Logo" />;
    $[0] = small;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== className || $[3] !== t2) {
    t3 = <StyledBrandBox className={className}>{t2}</StyledBrandBox>;
    $[2] = className;
    $[3] = t2;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  return t3;
};
export default Brand;
export { StyledBrandBox as BrandBox, BrandImage };
export type { BrandProps, BrandImageProps };